import React, { PureComponent } from "react";
import "./App.scss";
import { Route } from "react-router-dom";
import Login from "../login/Login";
import Logout from "../login/Logout";
import AppContainer from "../app/AppContainer";
import store from "../../store";
import IdleTimer from "react-idle-timer";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import axios from "axios";
import queryString from "query-string";

import { ModuleConfigContext } from "../ModuleConfigContext/ModuleConfigContext";

import {
  EventSource,
  ModuleMessaging,
  router,
  withEventDispatcher,
  ErrorPopupTitle
} from "clavis-nxt-components-custdevtm";
import ChangePasswordPage from "../ChangePassword/ChangePasswordPage";
import RegistrationPage from "../Registration/RegistrationPage";
import { LogOutModal } from "./LogOutModal";
const MySwal = withReactContent(Swal);
class App extends PureComponent {
  constructor(props) {
    super(props);

    this.stompClient = null;

    let environment = JSON.parse(localStorage.getItem("environment"));
    this.timeout =
      environment && environment.idleTimeout
        ? environment.idleTimeout * 1
        : 1800000; // default 30 mins

    this.timeOutCountDown = 30000; // 30 sec
    this.appRef = React.createRef();

    this.state = {
      needToSubscribeForTopicArray: [],
      displayLogOutModal: false,
      idleTimer: null
    };
  }

  stompSuccessCallBack = () => {
    console.debug("WS connected");
    console.log(
      "Need to subscribe for the following topics: ",
      this.state.needToSubscribeForTopicArray
    );

    for (let subscribe of this.state.needToSubscribeForTopicArray) {
      this.subscribeTopic(subscribe);
    }
    this.setState({ needToSubscribeForTopicArray: [] });
  };

  stompErrorCallback = () => {
    var timeout = 5000;
    console.error(
      "An error occured in the WS connection. Trying to reconnect in " +
        timeout / 1000 +
        " second(s)"
    );
    setTimeout(this.stompConnect, timeout);
  };

  stompConnect = () => {
    /*var wsUrl =
      process.env.REACT_APP_PLATFORM_SERVICES_WS_PATH ||
      "http://localhost:8080/platform-services/platform-services-ws";
    console.debug("WS connecting to " + wsUrl);

    var socket = new SockJS(wsUrl);

    this.stompClient = Stomp.over(socket);

    this.stompClient.debug = message => {};
    this.stompClient.connect(
      {},
      this.stompSuccessCallBack,
      this.stompErrorCallback
    );*/
  };

  subscribeTopic = payload => {
    console.log("Register for the " + payload.topic + " topic");
    this.stompClient.subscribe(
      payload.topic,
      message => {
        let parsedMessage = JSON.parse(message.body);
        console.log(
          "WS message arrived from the " + payload.topic + ", Message: ",
          parsedMessage
        );
        ModuleMessaging.dispatchWsEvent(
          payload.module,
          parsedMessage.dispatchEventName,
          parsedMessage
        );
      },
      { authToken: "authToken" }
    );
  };

  subscribeTopic = payload => {
    console.log("Register for the " + payload.topic + " topic");
    this.stompClient.subscribe(
      payload.topic,
      message => {
        let parsedMessage = JSON.parse(message.body);
        console.log(
          "WS message arrived from the " + payload.topic + ", Message: ",
          parsedMessage
        );
        ModuleMessaging.dispatchWsEvent(
          payload.module,
          parsedMessage.dispatchEventName,
          parsedMessage
        );
      },
      { authToken: "authToken" }
    );
  };

  componentDidMount() {
    this.props.eventDispatcher.subscribe(
      "web-platform",
      "ws-subscribe-to-topic",
      EventSource.CLIENT,
      payload => {
        if (this.stompClient && this.stompClient.connected) {
          this.subscribeTopic(payload);
        } else {
          console.log(
            "Waiting for the STOMP client for register the " +
              payload.topic +
              " topic"
          );
          let needToSubscribeForTopicArray = this.state
            .needToSubscribeForTopicArray;
          needToSubscribeForTopicArray.push(payload);
          this.setState({ needToSubscribeArray: needToSubscribeForTopicArray });
        }
      }
    );

    this.appRef.current.addEventListener("clavis-nxt-event", event => {
      store.dispatch({
        type: "CLAVIS_NXT_EVENT",
        source: event.detail.source,
        module: event.detail.module,
        eventName: event.detail.eventName,
        payload: event.detail.payload
      });
      this.props.eventDispatcher.dispatch(
        event.detail.module,
        event.detail.eventName,
        event.detail.source,
        event.detail.payload
      );
    });
    this.stompConnect();
  }

  generateAxiosBaseObject = context => {
    const axiosBaseObject = {};

    if (context && Object.hasOwn(context, "srv")) {
      axiosBaseObject["baseURL"] = context.srv;
      if (
        Object.hasOwn(context, "contextPath") &&
        typeof context.contextPath === "string"
      ) {
        axiosBaseObject["url"] = context.contextPath;
      }
    }

    return axiosBaseObject;
  };

  handleOnIdle = props => {
    const moduleConfig = localStorage.getItem("moduleConfig");
    const moduleConfigObject = JSON.parse(moduleConfig);
    if (moduleConfigObject.modules.gatekeeper) {
      console.log(moduleConfigObject.modules.gatekeeper);
      const axiosRequestObject = this.generateAxiosBaseObject(
        moduleConfigObject.modules.gatekeeper
      );

      axiosRequestObject["method"] = "POST";
      axiosRequestObject["data"] = queryString.stringify({
        token: sessionStorage.getItem("clavis.access_token")
      });
      axiosRequestObject["headers"] = {
        Authorization:
          "Basic Y2xhdmlzLW54dC1jdXN0ZGV2dG06aVVaTFlrSFRORlhIZXB6QWVpNVR4U3ZyNUlIZG42aDU=",
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      };
      axiosRequestObject["url"] = Object.hasOwn(axiosRequestObject, "url")
        ? `${
            axiosRequestObject.url
          }/realms/custdevtm-dev/protocol/openid-connect/revoke`
        : "realms/custdevtm-dev/protocol/openid-connect/revoke";

      axios(axiosRequestObject)
        .then(() => {
          this.hideAlertModal();
          sessionStorage.removeItem("clavis.access_token");
          sessionStorage.removeItem("clavis.authorities");
          sessionStorage.removeItem("clavis.refresh_token");
          sessionStorage.removeItem("clavis.access_token_expires");
          sessionStorage.removeItem("clavis.username");
          sessionStorage.removeItem("clavis.system_message");
          window.clavisNxtHistory.push("/logout", { forceReload: true });
        })
        .catch(error => {
          MySwal.fire({
            type: "error",
            showCloseButton: true,
            showConfirmButton: false,
            title: <ErrorPopupTitle data={error} />
          });
        });
    }
  };

  showAlertModal = () => {
    if (!this.state.displayLogOutModal) {
      this.setState({ displayLogOutModal: true });
    }
  };

  hideAlertModal = () => {
    if (this.state.displayLogOutModal) {
      this.setState({ displayLogOutModal: false });
    }
  };

  render() {
    return (
      <div>
        {this.props.location.pathname.indexOf("/nxt") !== -1 && (
          <IdleTimer
            ref={ref => {
              this.setState({ idleTimer: ref });
            }}
            onIdle={this.showAlertModal}
            onAction={this.hideAlertModal}
            timeout={
              this.state.displayLogOutModal
                ? this.timeOutCountDown
                : this.timeout
            }
            crossTab={{
              emitOnAllTabs: true
            }}
            events={[
              "mousemove",
              "keydown",
              "wheel",
              "DOMMouseScroll",
              "mousewheel",
              "mousedown",
              "visibilitychange",
              "focus"
            ]}
          />
        )}
        <ModuleConfigContext.Provider value={this.props.moduleConfig}>
          <div clavis-nxt-event-target="" ref={this.appRef}>
            {this.state.idleTimer && (
              <Route
                path="/nxt"
                component={() => (
                  <AppContainer idleTimer={this.state.idleTimer} />
                )}
              />
            )}
            <Route path="/login" exact component={Login} />
            <Route
              path="/changePassword"
              exact
              component={ChangePasswordPage}
            />
            <Route path="/registration" exact component={RegistrationPage} />
            <Route path="/logout" component={Logout} />
          </div>
          {this.state.displayLogOutModal && (
            <LogOutModal
              isOpen={this.state.displayLogOutModal}
              counter={this.timeOutCountDown}
              handleOnIdle={this.handleOnIdle}
            />
          )}
        </ModuleConfigContext.Provider>
      </div>
    );
  }
}

export default router(withEventDispatcher(App));
